/* eslint-disable max-len */
// Regroups all declared translation files

const translations = {
  // locale: 'fr_FR.json',

  locale: 'fr',
  Homepage: {
    combles_amenage_title: 'Combles aménagés',
    combles_perdues_title: 'Combles perdus',
    plafond_title: 'Plafond',
    isolation_murs_int: 'Isolation murs intérieurs',
    isolation_murs_ext: 'Isolations murs extérieurs',
    login: 'Se connecter',
    logout: 'Se déconnecter',
  },
  HeaderComponent: {
    login: 'Se connecter',
    logout: 'Se déconnecter',
  },
  Etape: {
    firststep: 'Projet',
    secondstep: 'Comparatif',
    thirdstep: 'Solution Basique',
    fourthstep: 'Solution Performante',
    fifthstep: 'Solution Optimale',
  },
  TypeUser: {
    title_user: 'PARTICULIERS',
    title_prescripteur: 'PRESCRIPTEURS',
    title_enterprise: 'ENTREPRISES DE POSES',
  },
  LoginComponent: {
    connexion_button: 'CONNEXION',
    createaccount: 'Créez un compte',
    error_login: 'Identifiants incorrects',
    error_user_not_activated: "L'email n'a pas encore été vérifié, merci de valider votre email !",
    everything: 'Tous les champs sont obligatoires',
    login_connexion: 'CONNEXION',
    login_email: 'E-MAIL ADDRESS',
    login_forgotpassword: 'Mot de passe oublié?',
    login_notmember: 'Pas encore membre ?',
    placeholder_email: 'Email',
    placeholder_password: 'Mot de passe',
    remember_me: 'Se souvenir de moi',
    wrong_type: 'Connexion impossible, mauvais type de compte choisi'
  },
  RegisterComponent: {
    register_title: 'INSCRIPTION',
    register_name: 'NOM',
    register_email: 'E-MAIL ADRESS',
    register_password: 'MOT DE PASSE',
    register_category: 'CATEGORIE',
    register_postalcode: 'CODE POSTAL',
    register_signin: 'INSCRIPTION',
    already_account: 'Vous avez déjà un compte?',
    register_connect: 'Connexion',
    value_table_particuliers: 'Particuliers',
    value_table_enterprises: 'Entreprises',
    value_table_prescripteurs: 'Prescripteurs',
    error_mail: "l'email existe déjà",
  },
  LandingComponent: {
    title_CA: 'Comparateur en comble aménagé',
    title_IME: "Comparateur d'isolation murs intérieurs",
    title_CP: 'Comparateur solutions KNAUF INSULATION en combles perdus',
    project_standard_title: 'Solution Basique',
    project_rtmax_title: 'Solution Performante',
    project_rtplus_title: 'Solution Optimale',
    solution_description: 'Description',
    standard_description_user: 'Isolation en comble aménagé avec membrane séparée et suspente traditionnelle',
    standard_description_entreprise: 'Isolation en comble aménagé avec membrane séparée et suspente traditionnelle',
    standard_description_prescripteur: 'Isolation en comble aménagé avec membrane séparée et suspente traditionnelle',
    standard_description_commercial: 'Isolation en comble aménagé avec membrane séparée et suspente traditionnelle',
    standard_description_pro: 'Isolation en comble aménagé avec membrane séparée et suspente traditionnelle, sans plenum entre la membrane et la plaque de finition',
    rtmax_description_user: 'Isolation en comble aménagé avec membrane séparée du Système RT Max, avec un plenum entre la membrane et la plaque de finition',
    rtmax_description_entreprise: 'Isolation en comble aménagé avec membrane séparée du Système RT Max, avec un plenum entre la membrane et la plaque de finition',
    rtmax_description_prescripteur: 'Isolation en comble aménagé avec membrane séparée du Système RT Max, avec un plenum entre la membrane et la plaque de finition',
    rtmax_description_commercial: 'Isolation en comble aménagé avec membrane séparée du Système RT Max, avec un plenum entre la membrane et la plaque de finition',
    rtplus_description_user: 'Isolation en comble aménagé avec membrane intégrée à l’isolant RT Plus, avec un plénum entre la membrane et la plaque de finition.',
    rtplus_description_entreprise: 'Isolation en comble aménagé avec membrane intégrée à l’isolant RT Plus, avec un plénum entre la membrane et la plaque de finition.',
    rtplus_description_prescripteur: 'Isolation en comble aménagé avec membrane intégrée à l’isolant RT Plus, avec un plénum entre la membrane et la plaque de finition.',
    rtplus_description_commercial: 'Isolation en comble aménagé avec membrane intégrée à l’isolant RT Plus, avec un plénum entre la membrane et la plaque de finition.',
    standard_description_user_IME: ' Isolation en murs avec le système Acoustizap 2 Néo',
    standard_description_entreprise_IME: ' Isolation en murs avec le système Acoustizap 2 Néo',
    standard_description_prescripteur_IME: ' Isolation en murs avec le système Acoustizap 2 Néo',
    standard_description_commercial_IME: ' Isolation en murs avec le système Acoustizap 2 Néo',
    standard_description_pro_IME: ' Isolation en murs avec le système Acoustizap 2 Néo',
    rtmax_description_user_IME: 'Isolation en mur avec membrane séparée RT Max, avec un plénum entre la membrane et la plaque de finition',
    rtmax_description_entreprise_IME: 'Isolation en mur avec membrane séparée RT Max, avec un plénum entre la membrane et la plaque de finition',
    rtmax_description_prescripteur_IME: 'Isolation en mur avec membrane séparée RT Max, avec un plénum entre la membrane et la plaque de finition',
    rtmax_description_commercial_IME: 'Isolation en mur avec membrane séparée RT Max, avec un plénum entre la membrane et la plaque de finition',
    rtplus_description_user_IME: "Isolation en mur avec membrane intégrée à l'isolant RT Plus, avec un plénum entre la membrane et la plaque de finition",
    rtplus_description_entreprise_IME: "Isolation en mur avec membrane intégrée à l'isolant RT Plus, avec un plénum entre la membrane et la plaque de finition",
    rtplus_description_prescripteur_IME: "Isolation en mur avec membrane intégrée à l'isolant RT Plus, avec un plénum entre la membrane et la plaque de finition",
    rtplus_description_commercial_IME: "Isolation en mur avec membrane intégrée à l'isolant RT Plus, avec un plénum entre la membrane et la plaque de finition",
    standard_description_user_CP: 'Isolation des combles perdus en une passe',
    rtmax_description_user_CP: 'Isolation des combles perdus en double passe',
    rtplus_description_user_CP: 'Isolation des combles perdus en laine à souffler',
    project_name_entreprise: 'Nom entreprise',
    entreprise_address: 'Adresse',
    entreprise_cp: 'CP',
    entreprise_town: 'Ville',
    project_description: 'Description du projet',
    project_name: 'Nom chantier',
    project_address: 'Adresse',
    project_cp: 'CP',
    project_ville: 'Ville',
    isolated_surface: 'Surface à isoler',
    isolated_surface_unit_value: 'm²',
    search_resistance: 'Résistance thermique recherchée',
    search_resistance_unit_value: 'm².K/W',
    dist_entre_chevrons: 'Hauteur disponible entre chevrons',
    dist_entre_chevrons_unit_value: 'cm',
    dist_sous_chevrons: 'Hauteur disponible sous chevrons',
    dist_sous_chevrons_unit_value: 'cm',
    resist_choice: 'Choisissez votre résistance thermique en bougeant le curseur',
    second_value_slider: 'C = Confort Eco / Obtention des aides',
    third_value_slider: 'B = Confort / RT 2012',
    fourth_value_slider: 'A = Confort Plus / Bepos',
    project_legend: 'Légende :',
    project_next_button: 'Suivant',
    dropdown_monobi: 'Isolant',
    unité_monocouche_bicouche: 'Type',
    R10: 'R = 10',
    R3: 'R = 3',
    R4: 'R = 4',
    R5: 'R = 5',
    R6: 'R = 6',
    R8: 'R = 8',
    value_dropdown_monocouche: 'Monocouche',
    value_dropdown_bicouche: 'Bicouche',
    incompatible_modal_epaisseur_resistance: "L'épaisseur du chevron et le niveau de résistance thermique sont incompatible pour proposer une solution.",
    incompatible_modal_ok: 'OK',
    title_modal_impossible_configuration: 'Configuration impossible',
  },
  TechnicalInfoIcon: {
    file_download: 'Télécharger la fiche technique',
  },
  ExportEmail: {
    export_email_title: 'EMAIL',
    export_email_label: 'E-MAIL ADDRESS',
    export_email_button: 'ENVOI EMAIL AVEC PDF',
  },
  ResetPassword: {
    reset_password_title: 'Réinitialiser votre mot de passe',
    reset_password_label: 'Merci de renseigner votre email',
    reset_password_button: 'ENVOYER',
  },
  CompareComponent: {
    title_CA: 'Comparatif général en comble aménagé',
    title_IME: "Comparatif général d'isolation murs intérieurs",
    title_CP: 'Comparateur solutions KNAUF INSULATION en combles perdus',
    compare_title_standard: 'Solution Basique (Tarif HT)',
    compare_title_rtmax: 'Solution Performante (Tarif HT)',
    compare_title_rtplus: 'Solution Optimale (Tarif HT)',
    compare_iso_entre_chevrons: 'Isolant entre chevrons',
    compare_iso_sous_chevrons: 'Isolant sous chevrons',
    compare_mur_ext_iso: 'Isolant murs',
    compare_tarif_horaire_mo: "Tarif horaire main d'oeuvre",
    compare_tarif_horaire_mo_standard: '€/heure',
    compare_tarif_horaire_mo_rtmax: '€/heure',
    compare_tarif_horaire_mo_rtplus: '€/heure',
    compare_nombre_dheure: "Nombre d'heures nécessaires",
    compare_heure_standard: 'heure(s)',
    compare_heure_rtmax: 'heure(s)',
    compare_heure_rtplus: 'heure(s)',
    compare_price_totalmo: "Prix total main d'oeuvre pour chantier",
    compare_price_totalmo_standard: '€',
    compare_price_totalmo_rtmax: '€',
    compare_price_totalmo_rtplus: '€',
    compare_price_mo: "Prix main d'oeuvre facturée au m²",
    compare_price_mo_standard: '€/m²',
    compare_price_mo_rtmax: '€/m²',
    compare_price_mo_rtplus: '€/m² ',
    compare_total_materiaux: 'Total matériaux',
    compare_total_materiaux_standard: '€',
    compare_total_materiaux_rtmax: '€',
    compare_total_materiaux_rtplus: '€',
    compare_total_mo: "Total main d'oeuvre",
    compare_total_mo_standard: '€',
    compare_total_mo_rtmax: '€',
    compare_total_mo_rtplus: '€',
    compare_total_facture: 'Total facturé en fourni posé',
    compare_total_facture_particulier: 'Total facturé en fourni posé (tarifs indicatifs)',
    compare_total_facture_standard: '€',
    compare_total_facture_rtmax: '€',
    compare_total_facture_rtplus: '€',
    total_facture_mcarre: 'Total facturé au m²',
    total_facture_mcarre_standard: '€/m²',
    total_facture_mcarre_rtmax: '€/m²',
    total_facture_mcarre_rtplus: '€/m²',
    reduction_rtmax: '%',
    reduction_rtplus: '%',
    compare_nextbutton: 'SUIVANT',
  },
  StandardSoluceComponent: {
    asterisk: '*Si vous êtes sur un plancher béton la pose d’un pare vapeur ne sera pas nécessaire.',
    standard_description_user_CP: 'Isolation des combles perdus en une passe',
    file_download: 'Télécharger la fiche technique',
    standard_solution_title: 'Solution Basique',
    standard_description_pro: 'Isolation en comble aménagé avec membrane séparée et suspente traditionnelle, sans plenum entre la membrane et la plaque de finition',
    standard_description_pro_IME: 'Isolation en murs avec le système Acoustizap 2 Néo',
    standard_tutorial_button: 'Tutoriel',
    standard_advantages_title: 'Avantages',
    standard_disadvantages_title: 'Inconvénients',
    standard_first_advantage_user: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    standard_second_advantage_user: 'Suppression des substances chimiques ajoutées : contribue au bien-être et à la santé des occupants',
    standard_third_advantage_user: 'Performance thermique',
    standard_first_advantage_user_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    standard_second_advantage_user_IME: 'Suppression des substances chimiques ajoutées : contribue au bien être et à la santé des occupants',
    standard_third_advantage_user_IME: 'Certifié Acermi',
    standard_first_advantage_CP: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    standard_second_advantage_CP: 'Fortes épaisseurs en monocouche : 280, 300 et 320 mm (Rd = 7,75 et 8,00)',
    standard_third_advantage_CP: 'Confort et facilité de pose grâce aux repères de coupe et de mesure',
    standard_fourth_advantage_CP: 'Reprise d\'épaisseur totale',
    standard_fifth_advantage_CP: 'Performances thermique et acoustique',
    standard_first_advantage_entreprise: 'Laine minérale de verre intégrant Ecose technology : confort de pose (Plus douce, moins poussiéreuse, non urticante)',
    standard_second_advantage_entreprise: 'Suppression des substances chimiques ajoutées : contribue au bien-être et à la santé des occupants',
    standard_third_advantage_entreprise: 'Performance thermique',
    standard_fourth_advantage_entreprise: 'Certifié Acermi',
    standard_first_advantage_entreprise_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    standard_second_advantage_entreprise_IME: 'Suppression des substances chimiques ajoutées : contribue au bien être et à la santé des occupants',
    standard_third_advantage_entreprise_IME: 'Certifié Acermi',
    standard_first_advantage_prescripteur: "Laine minérale de verre intégrant Ecose technology : limite les sources de pollutions à l'intérieur des bâtiments",
    standard_second_advantage_prescripteur: 'Liant à base végétale, sans formaldéhyde ajouté, ni acrylique, ni composés phénolique.',
    standard_third_advantage_prescripteur: "Différents labels attestants de l'inocuité de nos laines minérales de verre (Excell, Eurofins gold, A+)",
    standard_fourth_advantage_prescripteur: 'Produits sous FDES vérifées',
    standard_first_advantage_prescripteur_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    standard_second_advantage_prescripteur_IME: 'Suppression des substances chimiques ajoutées : contribue au bien être et à la santé des occupants',
    standard_third_advantage_prescripteur_IME: 'Certifié Acermi',
    standard_first_advantage_commercial: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    standard_second_advantage_commercial: 'Suppression des substances chimiques ajoutées : contribue au bien-être et à la santé des occupants',
    standard_third_advantage_commercial: 'Performance thermique ',
    standard_first_advantage_commercial_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    standard_second_advantage_commercial_IME: 'Suppression des substances chimiques ajoutées : contribue au bien être et à la santé des occupants',
    standard_third_advantage_commercial_IME: 'Certifié Acermi',
    standard_first_incovenience_user: "Aucun traitement de l'étanchéité à l'air",
    standard_second_incovenience_user: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_first_incovenience_user_IME: "Aucun traitement de l'étanchéité à l'air",
    standard_second_incovenience_user_IME: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_first_incovenience_user_CP: 'Temps de pose important',
    standard_second_incovenience_user_CP: 'Découpe de la laine minérale entre toutes les solives',
    standard_third_incovenience_user_CP: 'Poids des rouleaux',
    standard_first_incovenience_entreprise: "Aucun traitement de l'étanchéité à l'air",
    standard_second_incovenience_entreprise: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_third_incovenience_entreprise: "Aucun traitement de l'étanchéité à l'air",
    standard_fourth_incovenience_entreprise: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_first_incovenience_entreprise_IME: "Aucun traitement de l'étanchéité à l'air",
    standard_second_incovenience_entreprise_IME: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_first_incovenience_prescripteur: 'Risque de ponts thermiques en utilisant des suspentes métalliques standardisées',
    standard_second_incovenience_prescripteur: "Temps de mise en œuvre du système d'étanchéité très élevé ",
    standard_third_incovenience_prescripteur: "Etanchéité à la vapeur d'eau et à l'air pouvant être défectueuse dans le temps (système non garanti)",
    standard_first_incovenience_prescripteur_IME: "Aucun traitement de l'étanchéité à l'air",
    standard_second_incovenience_prescripteur_IME: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_first_incovenience_commercial: 'Risque de ponts thermiques en utilisant des suspentes métalliques standardisées',
    standard_second_incovenience_commercial: "Temps de mise en œuvre du système d'étanchéité très élevé ",
    standard_third_incovenience_commercial: "Etanchéité à l'eau et à l'air pouvant être défectueuse dans le temps (système non garanti)",
    standard_first_incovenience_commercial_IME: "Aucun traitement de l'étanchéité à l'air",
    standard_second_incovenience_commercial_IME: "Aucun traitement de l'étanchéité à la vapeur d'eau",
    standard_component_list: 'Liste des composants',
    standard_iso_entre_chevrons: ' Isolant entre chevrons',
    standard_iso_sous_chevrons: ' Isolant sous chevrons',
    standard_suspentes_trad: ' Suspentes traditionnelles',
    standard_membrane: ' Pare-vapeur ou Frein-vapeur RT Max',
    standard_adhesif: ' Adhésif RT Max',
    standard_solidouble: ' Solidouble',
    standard_mastic: ' Mastic RT',
    standard_iso_entre_solive: ' Isolant surfacé kraft',
    standard_iso_second_pass: ' Isolant 2 éme passe',
    standard_table_membrane_vap: 'Pare-vapeur RT MAX',
    rt_suspentes: 'Suspentes RT',
    IME_component_1: 'Isolant surfacé kraft',
    IME_component_2: 'Appuis intermédiaires ACOUSTIZAP 2 Néo ou Néo Réno',
    IME_component_3: 'Adhésif RT Max',
    CP_component_4: 'Pare-vapeur RT Max',
    CP_component_5: 'Adhésif RT Max',
    CP_component_6: 'Mastic RT',
    standard_reswait: 'Résistance attendue',
    standard_res_unit: 'm².K/W',
    standard_thermal_res: 'Résistance thermique',
    standard_thermal_res_unit: 'm².K/W',
    standard_conformity: "Conforme aux règles de l'art (DTU 45.10)",
    standard_conformity_CP: "Conforme aux règles de l'art (CPT 3560_V2 et DTA Combles) ?",
    standard_conformity_res: 'OUI',
    standard_conformity_resp: 'NON',
    standard_table_title: 'Composants',
    standard_table_title_quantity: 'Quantité',
    standard_table_title_unité: 'Tarif / Unité',
    standard_table_title_surface: 'Coût matériaux',
    standard_table_title_price_surface: 'Tarif / surface',
    standard_table_iso_entre_chevrons: 'Isolant entre chevrons',
    standard_table_iso_entre_chevrons_surface: 'm²',
    standard_table_iso_entre_chevrons_rouleau: ' rouleaux',
    standard_table_iso_entre_chevrons_price: '€/m²',
    standard_table_iso_entre_chevrons_tarifsurface: '€',
    standard_table_iso_sous_chevrons: 'Isolant sous chevrons',
    standard_table_iso_sous_chevrons_surface: 'm²',
    standard_table_iso_sous_chevrons_rouleau: ' rouleaux',
    standard_table_iso_sous_chevrons_price: '€/m²',
    standard_table_iso_sous_chevrons_tarifsurface: '€',
    standard_table_suspentes_trad: 'Suspentes traditionnelles',
    standard_table_suspentes_RT: 'Suspentes RT',
    standard_table_suspentes_surface: ' pièces',
    standard_table_suspentes_boites: ' boites',
    standard_table_suspentes_price: '€/boite',
    standard_table_suspentes_tarifsurface: '€',
    standard_table_membrane: 'Membrane',
    standard_table_membrane_cp: 'Pare-vapeur RT MAX',
    standard_table_membrane_surface: 'm²',
    standard_table_membrane_rouleau: ' rouleaux',
    standard_table_membrane_price: '€/rouleau',
    standard_table_membrane_tarifsurface: '€',
    standard_table_adhesif: 'Adhésif RT Max',
    standard_table_adhesif_surface: 'ml',
    standard_table_adhesif_rouleau: ' rouleaux',
    standard_table_adhesif_price: '€/rouleau',
    standard_table_adhesif_tarifsurface: '€',
    standard_table_solidouble: 'Solidouble',
    standard_table_solidouble_surface: 'ml',
    standard_table_solidouble_rouleau: ' rouleaux',
    standard_table_solidouble_price: '€/rouleau',
    standard_table_solidouble_tarifsurface: '€',
    standard_table_mastic: 'Mastic RT',
    standard_table_mastic_surface: 'ml',
    standard_table_mastic_cartouches: ' cartouches',
    standard_table_mastic_price: '€/cartouches',
    standard_table_mastic_tarifsurface: '€',
    standard_table_insulator: 'Isolant',
    standard_table_insulator_between: 'Isolant',
    standard_table_insulator_second: 'Isolant 2 éme passe',
    standard_table_insulator_surface: 'm2',
    standard_table_insulator_roll: 'rouleaux',
    standard_table_insulator_price: '€/m²',
    standard_table_insulator_tarifsurface: '€',
    standard_table_intermediate_supports: 'Acoustizap 2 Néo',
    standard_table_intermediate_supports_surface: 'piéces',
    standard_table_intermediate_supports_roll: 'boites',
    standard_table_intermediate_supports_price: '€/boite',
    standard_table_intermediate_supports_tarifsurface: '€',
    standard_total: 'TOTAL matériaux',
    standard_nextbutton: 'SUIVANT',
    incompatible_modal_standard_resistance: 'Solution non possible en Monocouche, la résistance thermique ne doit pas être superieure à 8',
    incompatible_modal_ok: 'RETOUR',
    incompatible_modal_epaisseur_resistance: "L'épaisseur du chevron et le niveau de résistance thermique sont incompatibles pour proposer une solution.",
    title_modal_impossible_configuration: 'Configuration impossible',
    incompatible_r: 'Pas de solution basique pour cette résistance',
    incompatible_modal_next: 'solution suivantes',
  },
  rtMaxSoluceComponent: {
    asterisk: '*Si vous êtes sur un plancher béton la pose d’un pare vapeur ne sera pas nécessaire.',
    rtmax_description_user_CP: 'Isolation des combles perdus en double passe',
    file_download: 'Télécharger la fiche technique',
    rtmax_solution_title: 'Solution Performante',
    rtmax_solution_description: 'Isolation en comble aménagé avec membrane séparée et Suspente RT de la gamme RT Max, avec un plenum entre la membrane et la plaque de finition',
    rtmax_solution_description_IME: ' Isolation en mur avec membrane séparée RT Max, avec un plénum entre la membrane et la plaque de finition',
    rtmax_tutorial_button: 'Tutoriel ',
    rtmax_advantages_title: 'Avantages',
    rtmax_disadvantages_title: 'Inconvénients',
    rtmax_first_advantage_user: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    rtmax_second_advantage_user: 'Suspente RT en matière composite pour une réduction des ponts thermiques',
    rtmax_third_advantage_user: 'Bonne performance thermique',
    rtmax_fourth_advantage_user: "Pérenité de l'ouvrage grâce à nos membranes de la gamme RT Max testées et approuvées",
    rtmax_fifth_advantage_user: 'Bonne performance thermique et acoustique ',
    rtmax_first_advantage_user_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtmax_second_advantage_user_IME: 'Système RT Max mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtmax_third_advantage_user_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau du mur",
    rtmax_fourth_advantage_user_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum, assurabilité des travaux',
    rtmax_fifth_advantage_user_IME: 'Bonne performance thermique et acoustique ',
    rtmax_first_advantage_entreprise: 'Laine minérale de verre intégrant Ecose technology : confort de pose (Plus douce, moins poussiéreuse, non urticante)',
    rtmax_second_advantage_entreprise: "Suspente RT Max : création automatique d'un plenum de 45 mm entre la membrane et la plaque de plâtre pour le passage des gaines électriques.",
    rtmax_third_advantage_entreprise: 'Suspente RT Max en matière composite et sans arrêtes saillantes : sécurité sur chantier',
    rtmax_fourth_advantage_entreprise: 'KI système garanti : produits testés et développés pour un fonctionnement optimum - assurabilité des travaux',
    rtmax_fifth_advantage_entreprise: 'Bonne performance thermique et acoustique',
    rtmax_first_advantage_entreprise_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtmax_second_advantage_entreprise_IME: 'Système RT Max mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtmax_third_advantage_entreprise_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau du mur",
    rtmax_fourth_advantage_entreprise_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum, assurabilité des travaux',
    rtmax_fifth_advantage_entreprise_IME: 'Bonne performance thermique et acoustique ',
    rtmax_first_advantage_prescripteur: "Laine minérale de verre intégrant Ecose technology : limite les sources de pollutions à l'intérieur des bâtiments",
    rtmax_second_advantage_prescripteur: 'Liant à base végétale, sans formaldéhyde ajouté, ni acrylique, ni composés phénoliques.',
    rtmax_third_advantage_prescripteur: 'KI système garanti : produits testés et développés pour un fonctionnement optimum - assurabilité des travaux',
    rtmax_fourth_advantage_prescripteur: 'Bonne performance thermique et acoustique ',
    rtmax_first_advantage_prescripteur_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtmax_second_advantage_prescripteur_IME: 'Système RT Max mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtmax_third_advantage_prescripteur_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau du mur",
    rtmax_fourth_advantage_prescripteur_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum, assurabilité des travaux',
    rtmax_fifth_advantage_prescripteur_IME: 'Bonne performance thermique et acoustique ',
    rtmax_first_advantage_commercial: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    rtmax_second_advantage_commercial: 'Suspente RT en matière composite pour une réduction des ponts thermiques ',
    rtmax_third_advantage_commercial: 'Bonne performance thermique',
    rtmax_fourth_advantage_commercial: "Pérenité de l'ouvrage grâce à nos membranes de la gamme RT Max testées et approuvées",
    rtmax_first_advantage_commercial_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtmax_second_advantage_commercial_IME: 'Système RT Max mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtmax_third_advantage_commercial_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau du mur",
    rtmax_fourth_advantage_commercial_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum, assurabilité des travaux',
    rtmax_fifth_advantage_commercial_IME: 'Bonne performance thermique et acoustique ',
    rtmax_first_incovenience_user: 'Temps de pose du pare vapeur séparé important ',
    rtmax_first_incovenience_entreprise: 'Temps de pose du pare vapeur séparé important',
    rtmax_first_incovenience_prescripteur: "Temps de mise en œuvre du système d'étanchéité élevé en raison de sa membrane séparée",
    rtmax_first_incovenience_commercial: "Temps de mise en œuvre du système d'étanchéité élevé en raison de sa membrane séparée",
    rtmax_first_incovenience_user_IME: 'Temps de pose du pare vapeur séparé important',
    rtmax_first_incovenience_entreprise_IME: 'Temps de pose du pare vapeur séparé important',
    rtmax_first_incovenience_prescripteur_IME: 'Temps de pose du pare vapeur séparé important',
    rtmax_first_incovenience_commercial_IME: 'Temps de pose du pare vapeur séparé important',
    rtmax_first_advantage_user_CP: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtmax_second_advantage_user_CP: 'Suppression des substances chimiques ajoutées : contribue au bien-être et à la santé des occupants',
    rtmax_third_advantage_user_CP: 'Performance thermique et acoustique',
    rtmax_fourth_advantage_user_CP: 'Etanchéité à l\'air et à la vapeur d\'eau',
    rtmax_first_incovenience_user_CP: 'Temps de pose important',
    rtmax_second_incovenience_user_CP: 'Découpe de la laine minérale entre toutes les solives',
    rtmax_third_incovenience_user_CP: 'Poids des rouleaux',
    rtmax_component_list: 'Liste des composants',
    rtmax_iso_entre_chevrons: ' Isolant entre chevrons',
    rtmax_iso_sous_chevrons: ' Isolant sous chevrons',
    rtmax_suspentes: ' Suspentes RT',
    rtmax_membrane: ' Pare-vapeur ou Frein-vapeur RT Max',
    rtmax_adhesif: ' Adhésif RT Max',
    rtmax_mastic: ' Mastic RT',
    rtmax_insulation: 'Isolant nu',
    rtmax_support: 'Appuis intermédiaires ACOUSTIZAP 2 Néo ou Néo Réno',
    rtmax_membrane_IME: ' Pare-vapeur ou Frein-vapeur RT Max',
    rtmax_pastille: ' Pastille RT',
    rtmax_adhesif_IME: ' Adhésif RT Max',
    rtmax_mastic_IME: ' Mastic RT',
    rtmax_conformity: "Conforme aux règles de l'art (DTU 45.10)",
    rtmax_conformity_res: 'OUI',
    rtmax_conformity_resp: 'NON',
    rtmax_reswait: 'Résistance attendue',
    rtmax_res_unit: 'm².K/W',
    rtmax_thermal_res: 'Résistance thermique',
    rtmax_thermal_res_unit: 'm².K/W',
    rtmax_table_title: 'Composants',
    table_title: 'Composants',
    rtmax_table_title_quantity: 'Quantité',
    table_title_quantity: 'Quantité',
    rtmax_table_title_unité: 'Tarif/Unité',
    table_title_unité: 'Tarif/Unité',
    rtmax_table_title_surface: 'Coût matériaux',
    table_title_surface: 'Coût matériaux',
    rtmax_table_iso_entre_chevrons: 'Isolant entre chevrons ',
    rtmax_table_iso_entre_chevrons_surface: 'm²',
    rtmax_table_iso_entre_chevrons_rouleau: ' rouleaux',
    rtmax_table_iso_entre_chevrons_price: '€/m²',
    rtmax_table_iso_entre_chevrons_tarifsurface: '€',
    rtmax_table_iso_sous_chevrons: 'Isolant sous chevrons',
    rtmax_table_iso_sous_chevrons_surface: 'm²',
    rtmax_table_iso_sous_chevrons_rouleau: ' rouleaux',
    rtmax_table_iso_sous_chevrons_price: '€/m²',
    rtmax_table_iso_sous_chevrons_tarifsurface: '€',
    rtmax_table_suspentes: 'Suspentes',
    rtmax_table_suspentes_surface: ' pièces',
    rtmax_table_suspentes_boites: ' boites',
    rtmax_table_suspentes_price: '€/boite',
    rtmax_table_suspentes_tarifsurface: '€',
    rtmax_table_membrane: 'Membrane',
    rtmax_table_membrane_surface: 'm²',
    rtmax_table_membrane_rouleau: ' rouleaux',
    rtmax_table_membrane_price: '€/m²',
    rtmax_table_membrane_tarifsurface: '€',
    rtmax_table_adhesif: 'Adhésif RT Max',
    rtmax_table_adhesif_surface: 'ml',
    rtmax_table_adhesif_rouleau: ' rouleaux',
    rtmax_table_adhesif_price: '€/rouleau',
    rtmax_table_adhesif_tarifsurface: '€',
    rtmax_table_mastic: 'Mastic RT',
    rtmax_table_mastic_surface: 'ml',
    rtmax_table_mastic_cartouches: ' cartouches',
    rtmax_table_mastic_price: '€/cartouche',
    rtmax_table_mastic_tarifsurface: '€',
    rtmax_table_insulation: 'Isolant',
    rtmax_table_insulation_surfaces: 'm²',
    rtmax_table_insulation_content_type: 'panneaux',
    rtmax_table_insulation_unit_price: '€/m²',
    rtmax_table_insulation_price: '€',
    rtmax_table_support: 'Acoustizap 2 Néo',
    rtmax_table_support_surfaces: 'pièces',
    rtmax_table_support_content_type: 'boites',
    rtmax_table_support_unit_price: '€/boite',
    rtmax_table_support_price: '€',
    rtmax_table_membrane_IME: 'Pare-vapeur RT MAX',
    rtmax_table_membrane_IME_surfaces: 'm²',
    rtmax_table_membrane_IME_content_type: 'rouleaux',
    rtmax_table_membrane_IME_unit_price: '€/rouleau',
    rtmax_table_membrane_IME_price: '€',
    rtmax_table_pastille: 'Pastille RT',
    rtmax_table_pastille_surfaces: 'pièces',
    rtmax_table_pastille_content_type: 'boites',
    rtmax_table_pastille_unit_price: '€/boite',
    rtmax_table_pastille_price: '€',
    rtmax_table_adhesif_IME: 'Adhésif RT Max',
    rtplus_table_adhesif_IME: 'Adhésif RT Plus',
    rtmax_table_adhesif_IME_surfaces: 'ml',
    rtmax_table_adhesif_IME_content_type: 'rouleaux',
    rtmax_table_adhesif_IME_unit_price: '€/rouleau',
    rtmax_table_adhesif_IME_price: '€',
    rtmax_table_mastic_IME: 'Mastic RT',
    rtmax_table_mastic_IME_surfaces: 'ml',
    rtmax_table_mastic_IME_content_type: 'cartouches',
    rtmax_table_mastic_IME_unit_price: '€/cartouche',
    rtmax_table_mastic_IME_price: '€',
    rtmax_total: 'TOTAL matériaux',
    rtmax_next_button: 'SUIVANT',
    incompatible_modal_ok: 'RETOUR',
    incompatible_modal_rtmax_resistance: 'Solution non possible en Monocouche, La résistance thermique ne doit pas être superieure à 8',
    incompatible_modal_epaisseur_resistance: "L'épaisseur du chevron et le niveau de résistance thermique sont incompatibles pour proposer une solution.",
    title_modal_impossible_configuration: 'Configuration impossible',
    CP_component_1: 'Isolant surfacé kraft première couche',
    CP_component_2: 'Isolant nu deuxième couche',
    CP_component_3: 'Pare-vapeur RT MAX',
    CP_component_4: 'ADHÉSIF RT Max',
    CP_component_5: 'Mastic RT',
    mm: 'mm',
    ml: 'ml',
    rolls: 'rouleaux',
    meter_square: 'm²',
    kg: 'Kg',
    cartridges: 'cartouches',
    euroKilo: '€/Kg',
    euroRoll: '€/rouleau',
    euroMeter: '€/m²',
    euroCartridges: '€/cartouches',
  },
  rtPlusSoluceComponent: {
    file_download: 'Télécharger la fiche technique',
    rtplus_solution_title: 'Solution Optimale',
    rtplus_solution_description: 'Isolation en comble aménagé avec membrane intégrée à l’isolant RT Plus, avec un plénum entre la membrane et la plaque de finition.',
    rtplus_solution_description_IME: "Isolation en mur avec membrane intégrée à l'isolant RT Plus, avec un plénum entre la membrane et la plaque de finition",
    rtplus_description_user_CP: 'Isolation des combles perdus en laine à souffler',
    rtplus_tutorial_button: 'Tutoriel ',
    rtplus_advantages_title: 'Avantages',
    rtplus_disadvantages_title: 'Inconvénients',
    rtplus_first_advantage_user_CP: 'Facilité et rapidité de pose',
    rtplus_second_advantage_user_CP: 'Excellente continuité thermique et acoustique',
    rtplus_third_advantage_user_CP: 'Certifié Acermi',
    rtplus_fourth_advantage_user_CP: 'Etanchéité à l\'air et à la vapeur d\'eau',
    rtplus_first_advantage_user: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    rtplus_second_advantage_user: 'Suspente RT en matière composite pour une réduction des ponts thermiques .',
    rtplus_third_advantage_user: 'Excellentes performances thermique et acoustique ',
    rtplus_fourth_advantage_user: "Optimisation et continuité de l'étanchéité à l'air et à la vapeur d'eau : système breveté",
    rtplus_fifth_advantage_user: "Pérennité de l'ouvrage assurée grâce à sa membrane intégrée - KI système  garanti ",
    rtplus_first_advantage_user_IME: 'Meilleure productivité sur chantier grâce au pare vapeur intégré = 25% de gain de temps sur chantier et confort de mise en œuvre',
    rtplus_second_advantage_user_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtplus_third_advantage_user_IME: 'Système RT Plus mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtplus_fourth_advantage_user_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau",
    rtplus_fifth_advantage_user_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum.',
    rtplus_sixth_advantage_user_IME: 'Système innovant, conformes aux réglementations. Assurabilité des travaux',
    rtplus_seventh_advantage_user_IME: 'Excellente performance thermique et acoustique',
    rtplus_first_advantage_entreprise: 'Laine minérale de verre intégrant Ecose technology : confort de pose (Plus douce, moins poussiéreuse, non urticante)',
    rtplus_second_advantage_entreprise: "Suspente RT Plus : création automatique d'un plenum de 45 mm entre la membrane et la plaque de plâtre pour le passage des gaines électriques.",
    rtplus_third_advantage_entreprise: 'Excellentes performances thermiques et acoustiques ',
    rtplus_fourth_advantage_entreprise: 'Système innovant sous Avis Technique, conforme aux réglementations. Assurabilité des travaux.',
    rtplus_fifth_advantage_entreprise: 'Meilleure productivité sur chantier grâce au pare vapeur intégré =  25% de gain de temps et confort de mise en œuvre',
    rtplus_first_advantage_entreprise_IME: 'Meilleure productivité sur chantier grâce au pare vapeur intégré = 25% de gain de temps sur chantier et confort de mise en œuvre',
    rtplus_second_advantage_entreprise_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtplus_third_advantage_entreprise_IME: 'Système RT Plus mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtplus_fourth_advantage_entreprise_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau",
    rtplus_fifth_advantage_entreprise_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum.',
    rtplus_sixth_advantage_entreprise_IME: 'Système innovant, conformes aux réglementations. Assurabilité des travaux',
    rtplus_seventh_advantage_entreprise_IME: 'Excellente performance thermique et acoustique',
    rtplus_first_advantage_prescripteur: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    rtplus_second_advantage_prescripteur: 'Suspente RT en matière composite pour une réduction des ponts thermiques ',
    rtplus_third_advantage_prescripteur: 'Excellentes performances thermiques et acoustiques ',
    rtplus_fourth_advantage_prescripteur: "Optimisation et continuité de l'étanchéité à l'air et à la vapeur d'eau : système breveté",
    rtplus_fifth_advantage_prescripteur: "Pérennité de l'ouvrage assurée grâce à sa membrane intégrée - KI système  garanti",
    rtplus_first_advantage_prescripteur_IME: 'Meilleure productivité sur chantier grâce au pare vapeur intégré = 25% de gain de temps sur chantier et confort de mise en œuvre',
    rtplus_second_advantage_prescripteur_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtplus_third_advantage_prescripteur_IME: 'Système RT Plus mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtplus_fourth_advantage_prescripteur_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau",
    rtplus_fifth_advantage_prescripteur_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum.',
    rtplus_sixth_advantage_prescripteur_IME: 'Système innovant, conformes aux réglementations. Assurabilité des travaux',
    rtplus_seventh_advantage_prescripteur_IME: 'Excellente performance thermique et acoustique',
    rtplus_first_advantage_commercial: "Laine minérale de verre intégrant Ecose technology : ne dégrade pas la qualité de l'air intérieur",
    rtplus_second_advantage_commercial: 'Suspente RT en matière composite pour une réduction des ponts thermiques ',
    rtplus_third_advantage_commercial: 'Excellentes performances thermiques et acoustiques ',
    rtplus_fourth_advantage_commercial: "Optimisation et continuité de l'étanchéité à l'air et à la vapeur d'eau : système breveté",
    rtplus_fifth_advantage_commercial: "Pérennité de l'ouvrage assurée grâce à sa membrane intégrée - KI système  garanti",
    rtplus_first_advantage_commercial_IME: 'Meilleure productivité sur chantier grâce au pare vapeur intégré = 25% de gain de temps sur chantier et confort de mise en œuvre',
    rtplus_second_advantage_commercial_IME: 'Laine minérale de verre intégrant Ecose Technology, confort de pose (plus douce, moins poussiéreuse, non urticante)',
    rtplus_third_advantage_commercial_IME: 'Système RT Plus mur : création automatique du plenum désiré entre la membrane et la plaque de plâtre pour le passage des gaines électriques',
    rtplus_fourth_advantage_commercial_IME: "Une garantie du traitement de l'étanchéité à l'air et de la vapeur d'eau",
    rtplus_fifth_advantage_commercial_IME: 'KI Système garanti : produits testés et développés pour un fonctionnement optimum.',
    rtplus_sixth_advantage_commercial_IME: 'Système innovant, conformes aux réglementations. Assurabilité des travaux',
    rtplus_seventh_advantage_commercial_IME: 'Excellente performance thermique et acoustique',
    rtplus_first_benefit_user: "Temps d'apprentissage sur le premier chantier",
    rtplus_first_benefit_entreprise: "Temps d'apprentissage sur le premier chantier",
    rtplus_first_benefit_prescripteur: "Temps d'apprentissage sur le premier chantier",
    rtplus_first_benefit_commercial: '',
    rtplus_first_benefit_user_IME: "Temps d'apprentissage sur le premier chantier",
    rtplus_first_benefit_entreprise_IME: "Temps d'apprentissage sur le premier chantier",
    rtplus_first_benefit_prescripteur_IME: "Temps d'apprentissage sur le premier chantier",
    rtplus_first_benefit_commercial_IME: '',
    rtplus_first_benefit_user_CP: 'Location de la machine',
    rtplus_component_list: 'Liste des composants',
    rtplus_iso_entre_chevrons: ' Isolant entre chevrons',
    rtplus_iso_sous_chevrons: ' Isolant RT Plus sous chevrons',
    rtplus_suspentes: ' Suspente RT',
    rtplus_manchons: ' Manchon RT Plus',
    rtplus_adhesif: ' Adhésif RT Plus',
    rtplus_mastic: ' Mastic RT',
    rtplus_insulate_IME: ' Isolant RT Plus',
    rtplus_support_IME: 'Appuis intermédiaires ACOUSTIZAP 2 Néo ou Néo Réno',
    rtplus_pastille: ' Pastille RT',
    rtplus_adhesif_IME: ' Adhésif RT Plus',
    rtplus_mastic_IME: ' Mastic RT',
    CP_component_1: 'Isolant à souffler',
    CP_component_2: 'Suspentes',
    CP_component_3: 'ADHÉSIF RT Max',
    CP_component_4: 'Pare-vapeur RT MAX',
    rtplus_reswait: 'Résistance attendue',
    rtplus_res_unit: 'm².K/W',
    rtplus_thermal_res: 'Résistance thermique',
    rtplus_thermal_res_unit: 'm².K/W',
    rtplus_conformity: "Conforme aux règles de l'art (DTU 45.10)",
    rtplus_conformity_cp: "Conforme aux règles de l'art (DTU 45.11)",
    rtplus_conformity_res: 'OUI',
    rtplus_conformity_resp: 'NON',
    rtplus_table_title: 'Composants',
    rtplus_table_title_quantity: 'Quantité',
    rtplus_table_title_unité: 'Tarif / Unité',
    rtplus_table_title_surface: 'Coût matériaux',
    rtplus_table_iso_entre_chevrons: 'Isolant entre chevrons',
    rtplus_table_iso_entre_chevrons_surface: 'm²',
    rtplus_table_iso_entre_chevrons_rouleau: ' rouleaux',
    rtplus_table_iso_entre_chevrons_price: '€/m²',
    rtplus_table_iso_entre_chevrons_tarifsurface: '€',
    rtplus_table_iso_sous_chevrons: 'Isolant sous chevrons',
    rtplus_table_iso_sous_chevrons_surface: 'm²',
    rtplus_table_iso_sous_chevrons_rouleau: ' rouleaux',
    rtplus_table_iso_sous_chevrons_price: '€/m²',
    rtplus_table_iso_sous_chevrons_tarifsurface: '€',
    rtplus_table_suspentes: 'Suspentes',
    rtplus_table_suspentes_surface: ' pièces',
    rtplus_table_suspentes_boites: ' boites',
    rtplus_table_suspentes_price: '€/boite',
    rtplus_table_suspentes_tarifsurface: '€',
    rtplus_table_manchon: 'Manchon RT Plus',
    rtplus_table_manchon_surface: ' pièces',
    rtplus_table_manchon_boite: ' boites de 50 ',
    rtplus_table_manchon_price: '€/boite',
    rtplus_table_manchon_tarifsurface: '€',
    rtplus_table_adhesif: 'Adhésif RT Plus ',
    rtplus_table_adhesif_surface: 'ml',
    rtplus_table_adhesif_rouleau: ' rouleaux',
    rtplus_table_adhesif_price: '€/rouleau',
    rtplus_table_adhesif_tarifsurface: '€',
    rtplus_table_adhesifxl: 'Adhésif RT Plus XL',
    rtplus_table_adhesifxl_surface: 'ml',
    rtplus_table_adhesifxl_rouleau: ' rouleaux',
    rtplus_table_adhesifxl_price: '€/rouleau',
    rtplus_table_adhesifxl_tarifsurface: '€',
    rtplus_table_mastic: 'Mastic RT',
    rtplus_table_mastic_surface: 'ml',
    rtplus_table_mastic_cartouches: ' cartouches',
    rtplus_table_mastic_price: '€/cartouche',
    rtplus_table_mastic_tarifsurface: '€',
    rtmax_table_insulation: 'Isolant RT Plus',
    rtmax_table_insulation_surfaces: 'm²',
    rtmax_table_insulation_content_type: 'Rouleaux',
    rtmax_table_insulation_unit_price: '€/m²',
    rtmax_table_insulation_price: '€',
    rtmax_table_support: 'Appuis intermédiaires',
    rtmax_table_support_surfaces: 'pièces',
    rtmax_table_support_content_type: 'boites',
    rtmax_table_support_unit_price: '€/boite',
    rtmax_table_support_price: '€',
    rtmax_table_pastille: 'Pastille RT',
    rtmax_table_pastille_surfaces: 'pièces',
    rtmax_table_pastille_content_type: 'boites',
    rtmax_table_pastille_unit_price: '€/boite',
    rtmax_table_pastille_price: '€',
    rtmax_table_adhesif_IME: 'Adhésif RT Plus',
    rtmax_table_adhesif_IME_surfaces: 'ml',
    rtmax_table_adhesif_IME_content_type: 'rouleaux',
    rtmax_table_adhesif_IME_unit_price: '€/rouleau',
    rtmax_table_adhesif_IME_price: '€',
    rtmax_table_mastic_IME: 'Mastic RT',
    rtmax_table_mastic_IME_surfaces: 'ml',
    rtmax_table_mastic_IME_content_type: 'cartouches',
    rtmax_table_mastic_IME_unit_price: '€/cartouche',
    rtmax_table_mastic_IME_price: '€',
    rtplus_total: 'TOTAL materiaux',
    rtplus_button_next: 'ENVOYER LE PDF PAR EMAIL',
    download_pdf: 'Télécharger le PDF',
    incompatible_modal_ok: 'RETOUR',
    incompatible_modal_rtplus_resistance: 'Solution non possible en Monocouche, La résistance thermique ne doit pas être superieure à 6.5',
    incompatible_modal_rtplus_60: "Solution non possible en Bicouche, L'épaisseur du chevron de 60 mm et la résistance thermique sont incompatibles",
    incompatible_modal_rtplus_80: "Solution non possible en Bicouche, L'épaisseur du chevron de 80 mm et la résistance thermique sont incompatibles",
    incompatible_modal_epaisseur_resistance: "L'épaisseur du chevron et le niveau de résistance thermique sont incompatibles pour proposer une solution.",
    title_modal_impossible_configuration: 'Configuration impossible',
    not_all_data: 'Information',
    go_see_other_soluctions: 'Merci de consulter les solutions avant de télécharger le pdf.',
    mm: 'mm',
    ml: 'ml',
    rolls: 'rouleaux',
    kg: 'Kg',
    cartridges: 'cartouches',
    euroKilo: '€/Kg',
    euroRoll: '€/rouleau',
    meter_square: 'm²',
    euroCartridges: '€/cartouches',
    table_title: 'Composants',
    table_title_quantity: 'Quantité',
    table_title_unité: 'Tarif/Unité',
    table_title_surface: 'Coût matériaux',
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/translate/AllTranslations.js